import { useEffect } from 'react';
/**
 * A React hook that disables scrolling of the page
 *
 * @param disabled if true scroll is disabled on the page
 */
export const useDisableScroll = (disabled = true) => {
    useEffect(() => {
        const originalOverflow = document.body.style.overflow;
        if (disabled) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = originalOverflow;
        }
        return () => {
            document.body.style.overflow = originalOverflow;
        };
    }, [disabled]);
};
